// Forked from services/caseDocument.ts at `cases-pre-sr-fork` (Service Requests start as a copy of Cases).
// Comments below were written for Cases and still describe this file until the two diverge.
import type {
  IServiceRequestDocument,
  IServiceRequestUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createServiceRequestDocument,
  updateDocument: updateServiceRequestDocument,
  deleteDocument: deleteServiceRequestDocument,
} = makeDocumentService<IServiceRequestDocument, IServiceRequestUploadDocument>(
  '/api/servicerequestdocuments',
  'serviceRequestDocument'
)
